(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-products-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-all-products-directory]');

    roots.forEach((root) => {
      const filters = [...root.querySelectorAll('[data-category-target]')];
      const categorySections = [...root.querySelectorAll('[data-category-section]')];
      const curatedData = root.querySelector('[data-curated-product-handles]');
      const cache = new Map();
      const productRequestCache = new Map();
      const storefrontRoot = window.Shopify?.routes?.root || '/';
      const accessoryExcludedProductIds = new Set(['9450288972000', '9450290577632']);
      const accessoryGroups = [
        {
          label: root.dataset.accessoryChargingLabel,
          productIds: new Set([
            '9902167589088', '9902167785696', '9119943459040', '9053426090208',
            '9929391603936', '9192625537248', '9195092017376', '9973501690080',
            '9973518237920', '10039245177056', '10039253729504', '10074879361248',
            '10074912555232'
          ])
        },
        {
          label: root.dataset.accessoryWiredLabel,
          productIds: new Set(['9162285842656', '9721400426720', '9162287874272'])
        },
        {
          label: root.dataset.accessoryDisposableLabel,
          productIds: new Set(['9905362403552', '9724018163936'])
        },
        {
          label: root.dataset.accessoryCablesLanyardLabel,
          productIds: new Set(['10039296557280', '9178142441696', '9092167500000'])
        }
      ];
      let curatedHandles = {};

      try {
        const handleStrings = JSON.parse(curatedData?.textContent || '{}');
        curatedHandles = Object.fromEntries(
          Object.entries(handleStrings).map(([collectionHandle, handles]) => [
            collectionHandle,
            String(handles).split(',').map((handle) => handle.trim()).filter(Boolean)
          ])
        );
      } catch (error) {
        curatedHandles = {};
      }

      const storefrontUrl = (path) => `${storefrontRoot}${path.replace(/^\/+/, '')}`;

      const fetchProduct = (handle) => {
        if (!productRequestCache.has(handle)) {
          productRequestCache.set(handle, fetch(storefrontUrl(`products/${encodeURIComponent(handle)}.js`), {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          }).then((response) => response.ok ? response.json() : null));
        }

        return productRequestCache.get(handle);
      };

      const imageUrl = (source) => {
        if (!source) return '';

        const url = new URL(source, window.location.origin);
        url.searchParams.set('width', '360');
        return url.toString();
      };

      const productDescription = (product) => {
        const parser = document.createElement('div');
        parser.innerHTML = product.body_html || product.description || '';
        const firstBlock = parser.querySelector('p, li, h1, h2, h3, h4, h5, h6');
        const text = (firstBlock?.textContent || parser.textContent || '').replace(/\s+/g, ' ').trim();

        if (!text) {
          const title = product.title.toLowerCase();
          if (title.includes('headphone')) return 'Headphones for compatible Venucast listening systems.';
          if (title.includes('transmitter')) return 'Transmitter for compatible Venucast listening systems.';
          if (title.includes('earbud')) return 'Wired earbuds for compatible listening receivers.';
          if (title.includes('adapter')) return 'Audio or power adapter for compatible equipment.';
          return 'See product details for specifications and compatibility.';
        }

        const firstSentence = text.match(/^.*?[.!?](?:\s|$)/)?.[0]?.trim() || text;
        if (firstSentence.length <= 112) return firstSentence;
        return `${firstSentence.slice(0, 109).replace(/\s+\S*$/, '')}…`;
      };

      const createProductCard = (product) => {
        const card = document.createElement('a');
        const imageWrap = document.createElement('span');
        const name = document.createElement('span');
        const description = document.createElement('span');
        const source = product.images?.[0]?.src || product.featured_image || '';

        card.className = 'all-products-directory__product';
        card.href = storefrontUrl(`products/${encodeURIComponent(product.handle)}`);
        imageWrap.className = 'all-products-directory__product-image';
        name.className = 'all-products-directory__product-name';
        name.textContent = product.title;
        description.className = 'all-products-directory__product-description';
        description.textContent = productDescription(product);

        if (source) {
          const image = document.createElement('img');
          image.className = 'all-products-directory__main-image';
          image.src = imageUrl(source);
          image.alt = product.title;
          image.loading = 'lazy';
          image.width = 360;
          image.height = 360;
          imageWrap.appendChild(image);
        }

        card.append(imageWrap, name, description);
        return card;
      };

      const renderProducts = (grid, products, useAccessoryGroups = false) => {
        const fragment = document.createDocumentFragment();

        grid.classList.toggle('is-grouped', useAccessoryGroups);

        if (!products.length) {
          const empty = document.createElement('p');
          empty.className = 'all-products-directory__empty';
          empty.textContent = 'No products are currently available in this category.';
          fragment.appendChild(empty);
        } else if (useAccessoryGroups) {
          const assignedIds = new Set();
          const groups = accessoryGroups.map((group) => {
            const groupProducts = products.filter((product) => group.productIds.has(String(product.id)));
            groupProducts.forEach((product) => assignedIds.add(String(product.id)));
            return { label: group.label, products: groupProducts };
          });
          groups.push({
            label: root.dataset.accessoryOtherLabel,
            products: products.filter((product) => !assignedIds.has(String(product.id)))
          });

          groups.forEach((group) => {
            if (!group.products.length) return;

            const section = document.createElement('section');
            const heading = document.createElement('h2');
            const groupGrid = document.createElement('div');
            section.className = 'all-products-directory__group';
            heading.className = 'all-products-directory__group-title';
            heading.textContent = group.label;
            groupGrid.className = 'all-products-directory__group-grid';
            group.products.forEach((product) => groupGrid.appendChild(createProductCard(product)));
            section.append(heading, groupGrid);
            fragment.appendChild(section);
          });
        } else {
          products.forEach((product) => fragment.appendChild(createProductCard(product)));
        }

        grid.replaceChildren(fragment);
      };

      const setActiveFilter = (activeFilter) => {
        filters.forEach((filter) => {
          const isActive = filter === activeFilter;
          filter.classList.toggle('is-active', isActive);
          if (isActive) {
            filter.setAttribute('aria-current', 'location');
          } else {
            filter.removeAttribute('aria-current');
          }
        });
      };

      const loadCollection = async (categorySection) => {
        const handle = categorySection.dataset.collectionHandle;
        const label = categorySection.dataset.categoryLabel;
        const filter = filters.find((item) => item.dataset.collectionHandle === handle);
        const grid = categorySection.querySelector('[data-products-grid]');
        const status = categorySection.querySelector('[data-products-status]');
        const expectedCount = Number.parseInt(status?.textContent, 10) || 0;

        if (!handle || !grid || !status) return;

        categorySection.setAttribute('aria-busy', 'true');
        status.textContent = `Loading ${label}…`;

        try {
          let products = cache.get(handle);

          if (!products) {
            const curatedProductHandles = curatedHandles[handle];

            if (curatedProductHandles?.length) {
              products = (await Promise.all(curatedProductHandles.map(fetchProduct))).filter(Boolean);
            } else {
              const response = await fetch(storefrontUrl(`collections/${encodeURIComponent(handle)}/products.json?limit=250`), {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' }
              });
              if (!response.ok) throw new Error('Unable to load products');
              const data = await response.json();
              products = data.products || [];
            }

            if (!products.length && expectedCount > 0) {
              throw new Error('Localized collection returned no products');
            }
            cache.set(handle, products);
          }

          const visibleProducts = handle === 'accessories-for-auracast-assistive-listening-systems'
            ? products.filter((product) => !accessoryExcludedProductIds.has(String(product.id)))
            : products;

          renderProducts(grid, visibleProducts);
          status.textContent = `${visibleProducts.length} ${visibleProducts.length === 1 ? 'product' : 'products'}`;
          const filterCount = filter?.querySelector('.all-products-directory__count');
          if (filterCount) filterCount.textContent = visibleProducts.length;
        } catch (error) {
          status.textContent = `Products could not be refreshed for ${label}. Showing the current list.`;
        } finally {
          categorySection.setAttribute('aria-busy', 'false');
        }
      };

      filters.forEach((filter) => {
        const curatedCount = curatedHandles[filter.dataset.collectionHandle]?.length;
        const count = filter.querySelector('.all-products-directory__count');
        if (curatedCount && count) count.textContent = curatedCount;
        filter.addEventListener('click', () => setActiveFilter(filter));
      });

      const syncActiveFilter = () => {
        const activeFilter = filters.find((filter) => filter.hash === window.location.hash);
        if (activeFilter) setActiveFilter(activeFilter);
      };

      window.addEventListener('hashchange', syncActiveFilter);
      syncActiveFilter();

      Promise.all(categorySections.map(loadCollection)).then(() => {
        const targetId = decodeURIComponent(window.location.hash.slice(1));
        const target = targetId ? document.getElementById(targetId) : null;
        if (target && root.contains(target)) target.scrollIntoView({ block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-hearing-access"] && !Shopify.designMode) return;
  try {
    

function bindCommunityForm(root) {
  root.querySelectorAll('[data-vch-form]').forEach((form) => {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (form.dataset.sending === 'true' || !form.reportValidity()) return;
      const button = form.querySelector('button[type="submit"]');
      const error = form.querySelector('.form-error');
      const success = form.querySelector('.form-success');
      const label = button.innerHTML;
      const data = new FormData(form);
      data.set('page_url', window.location.origin + window.location.pathname);
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      form.dataset.sending = 'true';
      button.disabled = true;
      button.textContent = form.dataset.submitting;
      error.hidden = true;
      try {
        const response = await fetch(form.action, {
          method: 'POST', body: data, headers: { Accept: 'application/json' }, signal: controller.signal
        });
        const result = await response.json();
        if (!response.ok || result.ok === false || result.errors) throw new Error('Submission failed');
        form.querySelector('[data-vch-fields]').hidden = true;
        success.hidden = false;
        success.focus();
      } catch (e) {
        error.textContent = form.dataset.error;
        error.hidden = false;
        error.focus();
      } finally {
        clearTimeout(timer);
        delete form.dataset.sending;
        button.disabled = false;
        button.innerHTML = label;
      }
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => bindCommunityForm(document), { once: true });
} else {
  bindCommunityForm(document);
}
document.addEventListener('shopify:section:load', (event) => bindCommunityForm(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-product-content"] && !Shopify.designMode) return;
  try {
    
if (!window.__croAjaxCartInitialized) {
  window.__croAjaxCartInitialized = true;

  const updateCartCount = (cart) => {
    const count = Number(cart?.item_count || 0);

    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      bubble.classList.remove('hidden');
      bubble.removeAttribute('hidden');

      const visibleCount =
        bubble.querySelector('[aria-hidden="true"]') ||
        bubble.querySelector('span:not(.visually-hidden)');
      const accessibleCount = bubble.querySelector('.visually-hidden');

      if (visibleCount) {
        visibleCount.textContent = String(count);
      } else if (!accessibleCount) {
        bubble.textContent = String(count);
      }

      if (accessibleCount) {
        accessibleCount.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
      }
    });

    document.querySelectorAll('[data-cart-count]').forEach((counter) => {
      counter.textContent = String(count);
    });
  };

  const refreshCartCount = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Unable to refresh cart');
    }

    const cart = await response.json();
    updateCartCount(cart);
    return cart;
  };

  document.addEventListener('keydown', (event) => {
    const button = event.target instanceof Element
      ? event.target.closest('[data-cro-add-to-cart]')
      : null;
    if (!button || (event.key !== 'Enter' && event.key !== ' ')) return;

    event.preventDefault();
    button.click();
  }, true);

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cro-add-to-cart]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const label = button?.querySelector('span');
    const status = button.parentElement?.querySelector('[data-cro-cart-status]');
    const variantId = button.dataset.variantId;
    if (!variantId || button.dataset.loading === 'true') return;

    const defaultLabel = button.dataset.defaultLabel || label?.textContent || 'Add to Cart';
    const productTitle = button.dataset.productTitle || 'Product';
    button.dataset.loading = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding...';
    if (status) status.textContent = `Adding ${productTitle} to cart.`;

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1,
            properties: button.dataset.isPreorder === 'true' ? { '_Pre-order': 'Yes' } : {}
          }]
        })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Unable to add item');
      }

      const cart = await refreshCartCount();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
      if (label) label.textContent = 'Added';
      if (status) {
        const count = Number(cart?.item_count || 0);
        status.textContent = `${productTitle} added to cart. Cart now has ${count} ${count === 1 ? 'item' : 'items'}.`;
      }
    } catch (error) {
      if (label) label.textContent = 'Try again';
      if (status) status.textContent = `Unable to add ${productTitle} to cart. ${error.message}`;
    } finally {
      window.setTimeout(() => {
        button.dataset.loading = 'false';
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = defaultLabel;
      }, 1400);
    }
  }, true);

  window.addEventListener('pageshow', () => {
    refreshCartCount().catch(() => {});
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {
    console.log("sticky full: " + sticky)

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            // 向下滚动时不隐藏头部，只保留 sticky 状态。
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hearing-access-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-print-guide]')) window.print();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-preview-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vc-home-hero]').forEach((root) => {
    if (root.dataset.vcReady === 'true') return;
    root.dataset.vcReady = 'true';

    const slides = Array.from(root.querySelectorAll('[data-vc-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-vc-dot]'));
    let current = 0;

    const show = (index) => {
      current = index;
      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === current ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
      });
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => show(index));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-feedback-neutual"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFeedback = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const actions = root.querySelector('[data-feedback-actions]');
      const confirmation = root.querySelector('[data-feedback-confirmation]');
      const barStatus = root.querySelector('[data-feedback-bar-status]');
      const yesButton = root.querySelector('[data-feedback-yes]');
      const noButton = root.querySelector('[data-feedback-no]');
      const dialog = root.querySelector('[data-feedback-dialog]');
      const closeButton = root.querySelector('[data-feedback-close]');
      const form = root.querySelector('[data-feedback-form]');
      const comment = root.querySelector('[data-feedback-comment]');
      const submit = root.querySelector('[data-feedback-submit]');
      const modalStatus = root.querySelector('[data-feedback-modal-status]');

      if (!actions || !confirmation || !barStatus || !yesButton || !noButton || !dialog || !closeButton || !form || !comment || !submit || !modalStatus) return;

      const submitLabel = submit.textContent;

      const payloadFor = (vote, reasons, otherText) => {
        const submittedAt = new Date().toISOString();

        return {
          subject: 'New Formspree submission - Venucast.com Vote',
          vote,
          reasons,
          other_text: otherText,
          comment: otherText,
          page_title: document.title,
          page_url: window.location.href.split('#')[0],
          page_path: window.location.pathname,
          page_type: root.dataset.pageType || 'unknown',
          product_handle: root.dataset.productHandle || '',
          product_id: root.dataset.productId || '',
          form_version: 'venucast-page-vote-v3',
          ui_version: 'compact-modal-v1',
          submitted_at: submittedAt,
          ts: submittedAt
        };
      };

      const setBusy = (busy) => {
        yesButton.disabled = busy;
        noButton.disabled = busy;
        submit.disabled = busy;
        submit.textContent = busy ? root.dataset.sendingLabel : submitLabel;
      };

      const send = async (payload) => {
        setBusy(true);

        try {
          const response = await fetch(root.dataset.endpoint, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          });

          if (!response.ok) throw new Error('Feedback request failed');
          return true;
        } catch (error) {
          return false;
        } finally {
          setBusy(false);
        }
      };

      const showComplete = () => {
        actions.hidden = true;
        barStatus.hidden = true;
        confirmation.hidden = false;
      };

      const hideDialog = (returnFocus) => {
        dialog.hidden = true;
        document.documentElement.classList.remove('vc-feedback-modal-open');
        modalStatus.hidden = true;
        if (returnFocus) noButton.focus();
      };

      const closeDialog = () => {
        hideDialog(true);
      };

      const openDialog = () => {
        dialog.hidden = false;
        document.documentElement.classList.add('vc-feedback-modal-open');
        closeButton.focus();
      };

      yesButton.addEventListener('click', async () => {
        barStatus.hidden = true;
        const sent = await send(payloadFor('Yes', [], ''));

        if (sent) {
          showComplete();
        } else {
          barStatus.textContent = root.dataset.errorMessage;
          barStatus.hidden = false;
        }
      });

      noButton.addEventListener('click', () => {
        modalStatus.hidden = true;
        openDialog();
      });

      closeButton.addEventListener('click', closeDialog);

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !dialog.hidden) {
          closeDialog();
        }
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        modalStatus.hidden = true;

        const reasons = Array.from(form.querySelectorAll('input[name="reason"]:checked')).map((input) => input.value);
        const sent = await send(payloadFor('Not yet', reasons, comment.value.trim()));

        if (sent) {
          form.reset();
          hideDialog(false);
          showComplete();
        } else {
          modalStatus.textContent = root.dataset.errorMessage;
          modalStatus.hidden = false;
        }
      });
    };

    const initializeAll = (scope) => {
      if (scope.matches?.('[data-vc-feedback]')) initializeFeedback(scope);
      scope.querySelectorAll?.('[data-vc-feedback]').forEach(initializeFeedback);
    };

    initializeAll(document);
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-shipping-reference"]) return;
  try {
    
(function(){
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('[data-vcsr-search]');
    const rows = Array.from(root.querySelectorAll('[data-vcsr-row]'));
    const count = root.querySelector('[data-vcsr-count]');
    const heading = root.querySelector('[data-vcsr-results-heading]');
    const empty = root.querySelector('[data-vcsr-empty]');
    const clear = root.querySelector('[data-vcsr-clear]');
    const quick = Array.from(root.querySelectorAll('[data-vcsr-quick]'));
    const normalize = (value) => value.normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();
    const entries = rows.map(row => ({row, code:normalize(row.dataset.code), name:normalize(row.dataset.search)}));
    const filter = () => {
      const query = normalize(input.value);
      const exactCode = query.length === 2 && entries.some(entry => entry.code === query);
      let found = 0;
      entries.forEach(entry => {
        const show = !query || (exactCode ? entry.code === query : query.split(' ').every(part => entry.name.includes(part)));
        entry.row.hidden = !show;
        if (show) found++;
      });
      heading.textContent = query ? heading.dataset.searchTitle : heading.dataset.allTitle;
      count.textContent = root.dataset.countTemplate.replace('__COUNT__',String(found));
      empty.hidden = found !== 0;
      clear.hidden = input.value.length === 0;
      quick.forEach(button => button.setAttribute('aria-pressed',String(query === normalize(button.dataset.vcsrQuick))));
    };
    const reset = () => { input.value=''; filter(); input.focus(); };
    input.addEventListener('input',filter);
    input.addEventListener('keydown',event => { if(event.key==='Escape'){ event.preventDefault(); reset(); } });
    clear.addEventListener('click',reset);
    root.querySelector('[data-vcsr-reset]').addEventListener('click',reset);
    quick.forEach(button => button.addEventListener('click',() => {input.value=button.dataset.vcsrQuick;filter();}));
    filter();
  };
  document.querySelectorAll('[data-vcsr]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-vcsr]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-system-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('vc-system-builder')) return;
  class SystemBuilder extends HTMLElement {
    static validQuantity(value, variant) {
      const n = Number(value), min = Math.max(1, Number(variant.min || 1)), step = Math.max(1, Number(variant.step || 1));
      return String(value).trim() !== '' && Number.isSafeInteger(n) && n >= min && n <= Math.min(999, Number(variant.max || 999)) && (n - min) % step === 0;
    }
    static estimate(lines) {
      const subtotal = lines.reduce((sum, line) => sum + line.variant.price * line.quantity, 0);
      const rules = [{key:'bulk5', minimum:3, percent:5}, {key:'bulk10', minimum:10, percent:7}, {key:'bulk10', minimum:20, percent:10}];
      let savings = 0, applied = null;
      for (const rule of rules) {
        const eligible = lines.filter(line => line.product[rule.key] === true);
        if (eligible.reduce((sum, line) => sum + line.quantity, 0) < rule.minimum) continue;
        const amount = eligible.reduce((sum, line) => sum + Math.floor(line.variant.price * rule.percent / 100) * line.quantity, 0);
        if(amount > savings){savings = amount;applied = rule;}
      }
      return {subtotal, savings, total:subtotal - savings, lineSavings:lines.map(line=>applied && line.product[applied.key] === true ? Math.floor(line.variant.price * applied.percent / 100) * line.quantity : 0)};
    }
    static validSystem(lines, family) {
      return lines.length > 0 && lines.every(l => (l.product.family === family || l.product.role === 'accessory') && !l.pending && l.variant.available && SystemBuilder.validQuantity(l.quantity, l.variant) && SystemBuilder.validQuantity(lines.filter(other=>other.variant.id===l.variant.id).reduce((sum,other)=>sum+other.quantity,0),l.variant));
    }
    connectedCallback() {
      if(!this.outsideModelPointer)this.outsideModelPointer=event=>{if(!this.contains(event.target))this.querySelectorAll('[data-picker]').forEach(p=>this.closeModelMenu(p));};
      this.ownerDocument.addEventListener('pointerdown',this.outsideModelPointer);
      if (this.initialized) return;
      this.initialized = true;
      this.products = JSON.parse(this.querySelector('[data-products]').textContent);
      this.msg = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.lines = []; this.busy = false; this.uncertain = false; this.imageCache = new Map();
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency', currency:this.dataset.currency || 'USD'});
      this.root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
      this.family = this.querySelector('[data-family]');
      this.addEventListener('change', event => this.trackChange(event));
      this.addEventListener('click', event => this.trackClick(event));
      this.addEventListener('toggle', event => this.trackToggle(event), true);
      if ('IntersectionObserver' in window) {
        this.analyticsObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.track('module_view', {component:'module'});
          this.analyticsObserver.disconnect();
        }, {threshold:0.35});
        this.analyticsObserver.observe(this);
      }
      this.family.addEventListener('change', () => { if (!this.lines.length) this.refreshPickers(); });
      this.pickerTemplates = new Map(); this.rowSequence = 0;
      this.querySelectorAll('[data-picker]').forEach(picker => {
        this.pickerTemplates.set(picker.dataset.picker, picker.cloneNode(true));
        this.bindPicker(picker);
      });
      this.querySelector('[data-reset]').addEventListener('click', () => {this.lines = []; this.resetRows(); this.render(); this.refreshPickers(); this.status('');});
      this.querySelector('[data-cart]').addEventListener('click', () => this.addToCart());
      this.querySelector('.vsb__app').hidden = false;
      this.refreshPickers(); this.render();
    }
    text(key) {return this.msg[key] || key;}
    packNote(product) {return this.text(product.role==='accessory'?'accessory_pack':product.category==='neckloops'?'neckloop_pack_count':'device_pack').replace('{count}',String(product.unitsPerPack));}
    format(cents) {return this.money.format(cents / 100);}
    status(message, error=false) { const el=this.querySelector('[data-status]');el.textContent=message;el.dataset.error=String(error); }
    track(interactionName, details={}) {
      const parameters={
        interaction_name:interactionName,
        module_name:'build_my_own_system',
        system_family:this.family?.value || '',
        line_count:this.lines?.length || 0,
        ...details
      };
      Object.keys(parameters).forEach(key => parameters[key] == null && delete parameters[key]);
      if (typeof window.gtag === 'function') window.gtag('event','system_builder_interaction',parameters);
      else {
        window.dataLayer=window.dataLayer || [];
        window.dataLayer.push({event:'system_builder_interaction',...parameters});
      }
    }
    pickerDetails(element) {
      const picker=element.closest('[data-picker]');
      if (!picker) return {};
      const {product,variant}=this.selected(picker);
      return {
        component:'product_picker',
        device_role:picker.dataset.picker,
        product_handle:product?.handle || '',
        variant_id:variant?.id ? String(variant.id) : '',
        quantity:Number(picker.querySelector('[data-qty]')?.value || 0)
      };
    }
    trackChange(event) {
      const target=event.target;
      let interactionName='';
      if (target.matches('[data-family]')) interactionName='change_system_family';
      else if (target.matches('[data-category]')) interactionName='change_device_type';
      else if (target.matches('[data-model]')) interactionName='change_model';
      else if (target.matches('[data-variant]')) interactionName='change_variant';
      else if (target.matches('[data-qty]')) interactionName='change_picker_quantity';
      else if (target.closest('[data-lines]') && target.matches('input[type="number"]')) interactionName='change_summary_quantity';
      if (interactionName) this.track(interactionName,{...this.pickerDetails(target),value:String(target.value || '')});
    }
    trackClick(event) {
      const target=event.target.closest('button,a,summary,[role="option"]');
      if (!target || !this.contains(target)) return;
      let interactionName='';
      if (target.matches('[data-add]')) interactionName='confirm_selection';
      else if (target.matches('[data-another]')) interactionName='add_another';
      else if (target.matches('[data-remove-row]')) interactionName='remove_selection_row';
      else if (target.matches('[data-reset]')) interactionName='start_over';
      else if (target.matches('[data-cart]')) interactionName='add_system_to_cart';
      else if (target.matches('[data-cart-link]')) interactionName='view_cart';
      else if (target.matches('[data-product-link]')) interactionName='open_product';
      else if (target.matches('[data-model-trigger]')) interactionName='open_model_picker';
      else if (target.matches('[role="option"]')) interactionName='choose_model_option';
      else if (target.matches('.vsb__help-link')) interactionName='open_help';
      else if (target.closest('[data-lines]') && target.matches('button')) interactionName='remove_selection';
      else if (target.matches('.vsb__title-link')) interactionName='title_anchor';
      if (interactionName) this.track(interactionName,this.pickerDetails(target));
    }
    trackToggle(event) {
      const details=event.target;
      if (!details.matches('details') || !details.open) return;
      let interactionName='open_details';
      if (details.matches('.vsb__compat-details')) interactionName='open_compatibility';
      else if (details.matches('.vsb__product-details')) interactionName='open_product_details';
      else if (details.matches('.vsb__accessory')) interactionName='open_accessories';
      else if (details.matches('.vsb__offer')) interactionName='open_discount_details';
      this.track(interactionName,this.pickerDetails(details));
    }
    refreshPickers() {
      this.querySelectorAll('[data-picker]').forEach(p=>{this.populateCategories(p);this.populate(p);});
    }
    setConfirmed(picker, confirmed) {
      picker.dataset.confirmed = String(confirmed);
      
      picker.querySelector('[data-confirmed-note]').hidden = !confirmed;
      const button = picker.querySelector('[data-add]');
      button.textContent = (confirmed ? this.text('confirmed_button') : this.text('confirm')) + ' ✓';
      button.disabled = confirmed || this.busy || this.uncertain;
    }
    invalidatePicker(picker) {
      const line=this.lines.find(line=>line.picker===picker);
      if(line) line.pending=true;
      this.setConfirmed(picker,false);
      if(line){this.render();this.status(this.text('pending_confirmation'));}
    }
    bindPicker(picker) {
      this.setupModelPicker(picker);
      picker.querySelector('[data-remove-row]').addEventListener('click', () => this.removePicker(picker));
      picker.addEventListener('focusin', () => this.warmImages(picker));
      picker.addEventListener('pointerenter', () => this.warmImages(picker));
      picker.querySelector('[data-category]')?.addEventListener('change', () => {this.invalidatePicker(picker);this.populate(picker);});
      picker.querySelector('[data-model]').addEventListener('change', () => {this.invalidatePicker(picker);this.preview(picker, true);});
      picker.querySelector('[data-variant]').addEventListener('change', () => {this.invalidatePicker(picker);this.preview(picker, false);});
      picker.querySelector('[data-qty]').addEventListener('input', () => this.invalidatePicker(picker));
      picker.querySelector('[data-add]').addEventListener('click', () => this.add(picker));
      picker.querySelector('[data-another]').addEventListener('click', () => this.another(picker));
    }
    resetRows() {
      this.querySelectorAll('[data-picker-group]').forEach(group => {
        [...group.querySelectorAll('[data-picker]')].slice(1).forEach(row => row.remove());
        group.querySelector('[data-another]').hidden = false;
      });
    }
    another(picker) {
      if (this.busy || this.uncertain) return;
      const group = picker.closest('[data-picker-group]');
      const row = this.pickerTemplates.get(picker.dataset.picker).cloneNode(true);
      const suffix = '-row-' + (++this.rowSequence);
      const ids = new Map();
      row.querySelectorAll('[id]').forEach(el => {ids.set(el.id, el.id + suffix);el.id += suffix;});
      row.querySelectorAll('[for], [aria-controls], [aria-labelledby]').forEach(el => {
        ['for','aria-controls','aria-labelledby'].forEach(attr => {
          if(el.hasAttribute(attr)) el.setAttribute(attr,el.getAttribute(attr).split(' ').map(id=>ids.get(id)||id).join(' '));
        });
      });
      row.querySelector('.vsb__picker-head').hidden = true;
      group.querySelectorAll('[data-another]').forEach(button => button.hidden = true);
      group.append(row); this.bindPicker(row); this.populateCategories(row); this.populate(row);
      if(row.dataset.picker==='rx'){row.querySelector('[data-category]').focus({preventScroll:true});}
      else {row.querySelector('[data-model-trigger]').focus(); this.openModelMenu(row);} 
      this.status(this.text('choose_next'));
    }
    removePicker(row) {
      if(this.busy || this.uncertain) return;
      this.lines = this.lines.filter(line => line.picker !== row);
      const group = row.closest('[data-picker-group]');
      if(group.querySelectorAll('[data-picker]').length > 1) row.remove();
      else this.populate(row);
      group.querySelector('.vsb__picker-head').hidden = false;
      const rows = [...group.querySelectorAll('[data-picker]')];
      rows.forEach((item,index)=>item.querySelector('[data-another]').hidden=index!==rows.length-1);
      this.render(); this.status(this.text('selection_removed'));
      const target=rows.find(item=>item.dataset.confirmed!=='true');
      if(target) (target.querySelector('[data-category]')||target.querySelector('[data-model-trigger]')).focus({preventScroll:true});
      else rows[rows.length-1].querySelector('[data-another]').focus();
    }
    removeLine(line) {this.removePicker(line.picker);}
    populateCategories(picker) {
      const select=picker.querySelector('[data-category]');if(!select)return;
      const categories=[...new Set(this.products.filter(p=>p.family===this.family.value && p.role==='rx').map(p=>p.category))];
      if(this.products.some(p=>p.role==='accessory' && p.category==='accessories')) categories.push('accessories');
      select.replaceChildren(new Option(this.text('choose_type'),''));
      categories.forEach(category=>select.add(new Option(this.text(category),category)));
    }
    pickerProducts(picker) {
      const role=picker.dataset.picker,category=picker.querySelector('[data-category]')?.value;
      const devices=this.products.filter(p=>p.role===role && p.family===this.family.value && (role!=='rx'||!!category && p.category===category));
      if(role==='rx' && category==='accessories') {
        const accessories=this.products.filter(p=>p.role==='accessory' && p.category==='accessories');
        if(this.family.value==='audiplex') {
          const handles=['10-pack-wired-earbuds','10-pack-wired-on-ear-headphones','10-pack-wired-over-ear-headphones','freemic-w-wireless-headset-microphone-system','freemic-duo-wireless-microphone-kit'];
          return accessories.filter(p=>handles.includes(p.handle));
        }
        return accessories;
      }
      return devices;
    }
    populate(picker) {
      this.setConfirmed(picker, false);
      picker.querySelector('[data-qty]').value = 1;
      const select=picker.querySelector('[data-model]');
      select.replaceChildren(new Option(this.text('choose'),''));
      this.pickerProducts(picker).forEach(p=>select.add(new Option(p.title,String(p.id))));
      this.rebuildModelMenu(picker);
      this.preview(picker,true);
    }
    warmImages(picker) {
      
      this.pickerProducts(picker).forEach(p=>{
        [p.image,...p.variants.map(v=>v.image)].filter(Boolean).forEach(url=>{
          if(this.imageCache.has(url))return;
          const img=new Image();img.decoding='async';this.imageCache.set(url,img);img.src=url;
        });
      });
    }
    setupModelPicker(picker) {
      const select=picker.querySelector('[data-model]'), button=picker.querySelector('[data-model-trigger]'), menu=picker.querySelector('[data-model-menu]');
      picker.querySelector('[data-model-control]').hidden=false;select.hidden=true;
      picker.querySelector('[data-model-label]').htmlFor=button.id;
      button.addEventListener('click',()=>menu.hidden?this.openModelMenu(picker):this.closeModelMenu(picker));
      button.addEventListener('keydown',event=>{
        const options=[...menu.querySelectorAll('[role="option"]')];
        const current=options.findIndex(o=>o.id===button.getAttribute('aria-activedescendant'));
        if(['ArrowDown','ArrowUp','Home','End'].includes(event.key)){
          event.preventDefault();if(menu.hidden)this.openModelMenu(picker);
          let next=event.key==='Home'?0:event.key==='End'?options.length-1:Math.max(0,Math.min(options.length-1,current+(event.key==='ArrowDown'?1:-1)));
          this.activateModelOption(picker,options[next]);
        } else if(event.key==='Enter'||event.key===' '){
          event.preventDefault();if(menu.hidden)this.openModelMenu(picker);else this.chooseModelOption(picker,options[current]);
        } else if(event.key==='Escape'){event.preventDefault();this.closeModelMenu(picker);}
        else if(event.key==='Tab'){this.closeModelMenu(picker);}
        else if(event.key.length===1&&!event.ctrlKey&&!event.metaKey&&!event.altKey){
          const now=Date.now();picker.modelSearch=now-(picker.modelSearchTime||0)>700?'':picker.modelSearch||'';picker.modelSearch+=event.key.toLowerCase();picker.modelSearchTime=now;
          if(menu.hidden)this.openModelMenu(picker);
          const match=options.find(o=>o.textContent.toLowerCase().startsWith(picker.modelSearch));this.activateModelOption(picker,match);
        }
      });
      menu.addEventListener('pointerdown',event=>event.preventDefault());
      menu.addEventListener('click',event=>{const option=event.target.closest('[role="option"]');if(option&&menu.contains(option))this.chooseModelOption(picker,option);});
      picker.addEventListener('focusout',event=>{if(!picker.querySelector('[data-model-control]').contains(event.relatedTarget))this.closeModelMenu(picker);});
    }
    rebuildModelMenu(picker) {
      const select=picker.querySelector('[data-model]'),menu=picker.querySelector('[data-model-menu]');menu.replaceChildren();
      [...select.options].filter(o=>o.value).forEach(option=>{
        const product=this.products.find(p=>String(p.id)===option.value),item=document.createElement('div');
        item.id=menu.id+'-'+option.value;item.dataset.value=option.value;item.setAttribute('role','option');item.setAttribute('aria-selected','false');item.className='vsb__model-option';
        if(product.image){const img=document.createElement('img');img.src=product.image;img.alt='';img.width=44;img.height=44;img.loading='eager';img.decoding='async';item.append(img);}
        const title=document.createElement('span');title.textContent=product.title;item.append(title);menu.append(item);
      });
      this.closeModelMenu(picker);this.syncModelTrigger(picker);
    }
    syncModelTrigger(picker,product,variant) {
      const button=picker.querySelector('[data-model-trigger]');if(!button)return;
      button.querySelector('[data-model-name]').textContent=product?product.title:this.text(picker.dataset.picker==='rx'&&!picker.querySelector('[data-category]').value?'choose_type_first':picker.querySelector('[data-model]').options.length>1?'choose':'no_models');
      const img=button.querySelector('[data-model-thumb]'),url=variant?.image||product?.image;img.hidden=!url;if(url&&img.getAttribute('src')!==url)img.src=url;
      button.disabled=picker.querySelector('[data-model]').options.length<2;
      picker.querySelectorAll('[data-model-menu] [role="option"]').forEach(o=>o.setAttribute('aria-selected',String(o.dataset.value===String(product?.id))));
    }
    openModelMenu(picker) {
      this.querySelectorAll('[data-picker]').forEach(p=>{if(p!==picker)this.closeModelMenu(p);});
      const menu=picker.querySelector('[data-model-menu]'),button=picker.querySelector('[data-model-trigger]');
      menu.hidden=false;button.setAttribute('aria-expanded','true');this.warmImages(picker);
      const options=[...menu.querySelectorAll('[role="option"]')];this.activateModelOption(picker,options.find(o=>o.dataset.value===picker.querySelector('[data-model]').value)||options[0]);
    }
    closeModelMenu(picker) {
      const button=picker.querySelector('[data-model-trigger]');picker.querySelector('[data-model-menu]').hidden=true;button.setAttribute('aria-expanded','false');button.removeAttribute('aria-activedescendant');
    }
    activateModelOption(picker,option) {
      if(!option)return;picker.querySelectorAll('[data-model-menu] [role="option"]').forEach(o=>o.classList.toggle('is-active',o===option));
      picker.querySelector('[data-model-trigger]').setAttribute('aria-activedescendant',option.id);option.scrollIntoView({block:'nearest'});
    }
    chooseModelOption(picker,option) {
      if(!option)return;const select=picker.querySelector('[data-model]');select.value=option.dataset.value;select.dispatchEvent(new Event('change',{bubbles:true}));this.closeModelMenu(picker);picker.querySelector('[data-model-trigger]').focus();
    }
    disconnectedCallback() { this.ownerDocument.removeEventListener('pointerdown',this.outsideModelPointer);this.analyticsObserver?.disconnect(); }

    selected(picker) {
      const product=this.products.find(p=>String(p.id)===picker.querySelector('[data-model]').value);
      const variant=product?.variants.find(v=>String(v.id)===picker.querySelector('[data-variant]').value);
      return {product,variant};
    }
    preview(picker,resetVariant) {
      const product=this.products.find(p=>String(p.id)===picker.querySelector('[data-model]').value), preview=picker.querySelector('[data-preview]'), variantSelect=picker.querySelector('[data-variant]');
      const tip=picker.querySelector('[data-receiver-tip]');
      if(tip){tip.hidden=!product || product.unitsPerPack>1 || (product.role!=='accessory'&&product.category!=='receivers');tip.textContent=product?.role==='accessory'?product.note:this.text('receiver_tip');}
      picker.querySelector('[data-quantity-label]').textContent=this.text(product?.unitsPerPack>1?'pack_quantity':'quantity');
      preview.hidden=!product;picker.querySelector('[data-add]').disabled=picker.dataset.confirmed==='true'||this.busy||this.uncertain;
      picker.querySelector('[data-variant-wrap]').hidden=!product || product.variants.length<2;
      if (!product) {this.syncModelTrigger(picker);return;}
      if (resetVariant) {
        variantSelect.replaceChildren();
        product.variants.forEach(v=>{const option=new Option(v.title,String(v.id));variantSelect.add(option);});
        variantSelect.value=String((product.variants.find(v=>v.available)||product.variants[0]).id);
      }
      const {variant}=this.selected(picker); if(!variant)return;
      this.syncModelTrigger(picker,product,variant);
      const image=picker.querySelector('[data-image]'), imageUrl=variant.image || product.image;
      image.hidden=!imageUrl;image.loading='eager';
      if(imageUrl){if(image.getAttribute('src')!==imageUrl)image.src=imageUrl;image.alt=product.title+(variant.title==='Default Title'?'':' — '+variant.title);}
      picker.querySelector('[data-price]').textContent=this.format(variant.price);
      picker.querySelector('[data-note]').textContent=product.note;
      picker.querySelector('[data-stock]').textContent=!variant.available?this.text('preview_unavailable'):product.preorder?this.text('preorder'):this.text('available');
      const link=picker.querySelector('[data-product-link]');link.href=product.url+'?variant='+variant.id;
      const qty=picker.querySelector('[data-qty]');qty.min=variant.min;qty.step=variant.step;qty.max=Math.min(999,variant.max||999);if(resetVariant||!SystemBuilder.validQuantity(qty.value,variant))qty.value=variant.min;
      picker.querySelector('[data-add]').disabled=picker.dataset.confirmed === 'true'||this.busy||this.uncertain;
      if(picker.dataset.confirmed === 'true') this.setConfirmed(picker, true);
    }
    add(picker) {
      if (this.busy || this.uncertain || picker.dataset.confirmed === 'true') return;
      const {product,variant}=this.selected(picker), quantity=Number(picker.querySelector('[data-qty]').value);
      if(!product||!variant){this.status(this.text('choose'),true);(picker.querySelector('[data-category]')?.value ? picker.querySelector('[data-model-trigger]') : picker.querySelector('[data-category]')||picker.querySelector('[data-model-trigger]')).focus();return;}
      if(product.role!=='accessory' && product.family!==this.family.value){this.status(this.text('incompatible'),true);return;}
      const total=quantity+this.lines.filter(l=>l.picker!==picker&&l.variant.id===variant.id).reduce((sum,line)=>sum+line.quantity,0);
      if(!SystemBuilder.validQuantity(picker.querySelector('[data-qty]').value,variant)||!SystemBuilder.validQuantity(total,variant)){this.status(this.text('quantity_error'),true);return;}
      const existing=this.lines.findIndex(line=>line.picker===picker);
      const line={product,variant,quantity,picker,pending:false};
      if(existing<0)this.lines.push(line);else this.lines[existing]=line;
      this.setConfirmed(picker, true);this.closeModelMenu(picker);this.render();this.status(this.text('added'));picker.querySelector('[data-remove-row]').focus({preventScroll:true});
    }
    render() {
      const list=this.querySelector('[data-lines]');list.replaceChildren();
      const estimate = SystemBuilder.estimate(this.lines);
      this.lines.forEach((line,index)=>{
        const li=document.createElement('li');li.className='vsb__line';
        const info=document.createElement('div');info.className='vsb__line-info';
        const imageUrl=line.variant.image||line.product.image;
        if(imageUrl){const image=document.createElement('img');image.className='vsb__line-image';image.src=imageUrl;image.alt='';image.width=72;image.height=72;image.loading='lazy';li.append(image);}
        else li.classList.add('vsb__line--no-image');
        const name=document.createElement('strong');name.textContent=line.product.title;info.append(name);
        if(line.product.note){const description=document.createElement('p');description.className='vsb__line-description';description.textContent=line.product.note;info.append(description);}
        if(line.pending){const pending=document.createElement('small');pending.className='vsb__line-notice';pending.textContent=this.text('pending_confirmation');info.append(pending);}
        if(!line.variant.available){const stock=document.createElement('small');stock.className='vsb__line-notice';stock.textContent=this.text('preview_unavailable');info.append(stock);}
        const option=document.createElement('small');option.textContent=(line.variant.title==='Default Title'?'':line.variant.title+' · ')+this.format(line.variant.price);info.append(option);
        if(line.product.unitsPerPack>1){const pack=document.createElement('small');pack.textContent=this.packNote(line.product);info.append(pack);}
        if(line.product.preorder){const notice=document.createElement('small');notice.textContent=this.text('preorder');info.append(notice);}
        const input=document.createElement('input');input.type='number';input.inputMode='numeric';input.min=line.variant.min;input.max=Math.min(999,line.variant.max||999);input.step=line.variant.step;input.value=line.quantity;input.setAttribute('aria-label',this.text(line.product.unitsPerPack>1?'pack_quantity':'quantity')+' — '+line.product.title);
        input.addEventListener('change',()=>{if(!SystemBuilder.validQuantity(input.value,line.variant)||!SystemBuilder.validQuantity(Number(input.value)+this.lines.filter(other=>other!==line&&other.variant.id===line.variant.id).reduce((sum,other)=>sum+other.quantity,0),line.variant)){input.value=line.quantity;this.status(this.text('quantity_error'),true);return;}line.quantity=Number(input.value);line.picker.querySelector('[data-qty]').value=line.quantity;this.invalidatePicker(line.picker);});
        const amount=document.createElement('span');amount.className='vsb__line-price';
        const original=line.variant.price*line.quantity, saving=estimate.lineSavings[index];
        if(saving > 0){
          const before=document.createElement('s');before.textContent=this.format(original);before.setAttribute('aria-label',this.text('line_original')+' '+this.format(original));
          const after=document.createElement('strong');after.textContent=this.format(original-saving);after.setAttribute('aria-label',this.text('line_discounted')+' '+this.format(original-saving));
          const label=document.createElement('small');label.textContent=this.text('line_discounted');
          amount.append(before,after,label);
        } else amount.textContent=this.format(original);
        const remove=document.createElement('button');remove.type='button';remove.textContent=this.text('remove');remove.setAttribute('aria-label',this.text('remove')+' '+line.product.title);remove.addEventListener('click',()=>this.removeLine(line));
        li.append(info,input,amount,remove);list.append(li);
      });
      this.querySelector('[data-empty]').hidden=!!this.lines.length;
      this.querySelector('.vsb__summary').dataset.emptyState=String(this.lines.length===0);
      this.querySelector('[data-tx-count]').textContent=this.lines.filter(l=>l.product.role==='tx').reduce((n,l)=>n+l.quantity,0);
      this.querySelector('[data-rx-count]').textContent=this.lines.filter(l=>l.product.role==='rx').reduce((n,l)=>n+l.quantity*(l.product.unitsPerPack||1),0);

      this.querySelector('[data-before]').textContent = this.format(estimate.subtotal);
      this.querySelector('[data-before-row]').hidden = !this.lines.length;
      this.querySelector('[data-before]').classList.toggle('vsb__old-price', estimate.savings > 0);
      this.querySelector('[data-savings]').textContent = (estimate.savings > 0 ? '−' : '') + this.format(estimate.savings);
      this.querySelector('[data-savings-row]').hidden = !this.lines.length;
      this.querySelector('[data-total]').textContent = this.format(estimate.total);
      this.querySelector('[data-estimate-note]').hidden = !this.lines.length;
      const valid=SystemBuilder.validSystem(this.lines,this.family.value);
      this.querySelector('[data-cart]').disabled=!valid||this.busy||this.uncertain;
      this.querySelector('[data-need]').hidden=valid;
      this.querySelector('[data-need]').textContent=this.text(this.lines.some(l=>l.pending)?'pending_confirmation':this.lines.some(l=>!l.variant.available)?'cart_unavailable':'need_both');
      this.family.disabled=!!this.lines.length;
    }
    async getJson(url,options={}) {
      const controller=new AbortController();
      const timeout=setTimeout(()=>controller.abort(),25000);
      try {
        const response=await fetch(url,{credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok)throw new Error('HTTP '+response.status);
        return await response.json();
      } finally {clearTimeout(timeout);}
    }
    async addToCart() {
      if(this.busy||this.uncertain||!SystemBuilder.validSystem(this.lines,this.family.value))return;
      this.busy=true;const controls=this.querySelector('.vsb__controls');controls.disabled=true;
      const button=this.querySelector('[data-cart]');button.textContent=this.text('busy');
      let sent=false;
      try {
        const handles=[...new Set(this.lines.map(l=>l.product.handle))];
        const fresh=await Promise.all(handles.map(h=>this.getJson(this.root+'products/'+encodeURIComponent(h)+'.js')));
        let changed=false;
        this.lines.forEach(line=>{
          const p=fresh.find(p=>p.handle===line.product.handle),v=p?.variants.find(v=>v.id===line.variant.id);
          if(!v){line.variant.available=false;changed=true;return;}
          const rule=v.quantity_rule||{};const updated={price:v.price,available:v.available,min:rule.min||1,step:rule.increment||1,max:rule.max||999};
          if(Object.keys(updated).some(k=>line.variant[k]!==updated[k]))changed=true;
          Object.assign(line.variant,updated);
        });
        if(changed||!SystemBuilder.validSystem(this.lines,this.family.value)){this.status(this.text('changed'),true);return;}
        sent=true;
        await this.getJson(this.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...this.lines.reduce((items,line)=>{const item=items.get(line.variant.id)||{id:line.variant.id,quantity:0};item.quantity+=line.quantity;items.set(item.id,item);return items;},new Map()).values()]})});
        this.track('add_system_to_cart_success',{component:'cart',item_count:this.lines.reduce((sum,line)=>sum+line.quantity,0)});
        this.uncertain=true;this.status(this.text('added_cart'));this.querySelector('[data-cart-link]').hidden=false;
        window.location.assign(this.root+'cart');
      } catch(error) {
        this.track('add_system_to_cart_error',{component:'cart',request_sent:sent ? 'yes' : 'no'});
        this.uncertain=sent;this.status(this.text(sent?'error':'check_error'),true);this.querySelector('[data-cart-link]').hidden=!sent;
      } finally {
        this.busy=false;controls.disabled=false;button.textContent=this.text('cart');this.render();
        this.querySelectorAll('[data-picker]').forEach(p=>this.preview(p,false));
      }
    }
  }
  customElements.define('vc-system-builder',SystemBuilder);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venucast-shipping-policy"] && !Shopify.designMode) return;
  try {
    
  const root = document.querySelector('[data-vc-shipping-policy]');
  if (root) {
    const groups = [
      { origin:'United States', type:'local', min:2, max:5, countries:'US' },
      { origin:'Canada', type:'local', min:3, max:5, countries:'CA' },
      { origin:'United Kingdom', type:'local', min:3, max:5, countries:'GB' },
      { origin:'Europe', type:'local', min:3, max:5, countries:'DE,ES,FR,IT' },
      { origin:'Europe', type:'local', min:5, max:10, countries:'AT,BE,BG,CZ,DK,EE,FI,GR,HU,IE,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,SE,CY,HR' },
      { origin:'Australia', type:'local', min:3, max:7, countries:'AU' },
      { origin:'China', type:'international', min:7, max:13, countries:'JP,KR,MY,PH,SG,TH,TW,VN,NZ,CH,ID,IL' },
      { origin:'China', type:'international', min:8, max:13, countries:'AU' },
      { origin:'China', type:'international', min:7, max:12, countries:'CA,AT,BE,BG,CY,CZ,DE,DK,EE,ES,FI,FR,GB,GR,HR,HU,IE,IT,LT,LU,LV,MT,NL,PL,PT,RO,SE,SI,SK' },
      { origin:'China', type:'international', min:10, max:15, countries:'BH,IN,KW,QA,SA,TR,MX,AE' },
      { origin:'China', type:'international', min:10, max:20, countries:'NO' },
      { origin:'China', type:'international', min:15, max:25, countries:'AR,CL,CO,PE' },
      { origin:'China', type:'local', min:2, max:3, countries:'HK,MO,CN' },
      { origin:'China', type:'international', min:20, max:30, countries:'ZA' },
      { origin:'China', type:'international', min:15, max:30, countries:'DZ,AO,AC,BJ,BW,IO,BF,BI,CM,CV,CF,TD,KM,CG,CD,CI,DJ,EG,GQ,ER,SZ,ET,TF,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,YT,MA,MZ,NA,NE,NG,RE,RW,ST,SN,SC,SL,SO,SS,SH,SD,TZ,TG,TA,TN,UG,EH,ZM,AF,AM,AZ,BD,BT,BN,KH,GE,IQ,JO,KZ,KG,LA,LB,MV,MN,MM,NP,OM,PK,PS,LK,TJ,TL,TM,UZ,YE,AL,AD,BY,BA,FO,GI,GG,IS,IM,JE,XK,LI,MD,MC,ME,MK,RU,SM,RS,SJ,UA,VA,AI,AG,AW,BS,BB,BZ,BM,VG,BQ,KY,CR,CW,DM,DO,SV,GL,GD,GP,GT,HT,HN,JM,MQ,MS,NI,PA,SX,BL,KN,LC,MF,PM,VC,TT,TC,CX,CC,CK,FJ,PF,KI,NR,NC,NU,NF,PG,PN,WS,SB,TK,TO,TV,UM,VU,WF,BO,BR,EC,FK,GF,GY,PY,GS,SR,UY,VE,AX,ZW' }
    ];
    const continentGroups = [
      { code:'AF', countries:'AO,BF,BI,BJ,BW,CD,CF,CG,CI,CM,CV,DJ,DZ,EG,EH,ER,ET,GA,GH,GM,GN,GQ,GW,IO,KE,KM,LR,LS,LY,MA,MG,ML,MR,MU,MW,MZ,NA,NE,NG,RE,RW,SC,SD,SH,SL,SN,SO,SS,ST,SZ,TD,TF,TG,TN,TZ,UG,YT,ZA,ZM,ZW' },
      { code:'AS', countries:'AE,AF,AM,AZ,BD,BH,BN,BT,CN,CY,GE,HK,ID,IL,IN,IQ,JO,JP,KG,KH,KR,KW,KZ,LA,LB,LK,MM,MN,MO,MV,MY,NP,OM,PH,PK,PS,QA,SA,SG,TH,TJ,TL,TM,TR,TW,UZ,VN,YE' },
      { code:'EU', countries:'AD,AL,AT,AX,BA,BE,BG,BY,CH,CZ,DE,DK,EE,ES,FI,FO,FR,GB,GG,GI,GR,HR,HU,IE,IM,IS,IT,JE,LI,LT,LU,LV,MC,MD,ME,MK,MT,NL,NO,PL,PT,RO,RS,RU,SE,SI,SJ,SK,SM,UA,VA,XK' },
      { code:'NA', countries:'AG,AI,AW,BB,BL,BM,BQ,BS,BZ,CA,CR,CW,DM,DO,GD,GL,GP,GT,HN,HT,JM,KN,KY,LC,MF,MQ,MS,MX,NI,PA,PM,SV,SX,TC,TT,US,VC,VG' },
      { code:'SA', countries:'AR,BO,BR,CL,CO,EC,FK,GF,GS,GY,PE,PY,SR,UY,VE' },
      { code:'OC', countries:'AU,CC,CK,CX,FJ,KI,NC,NF,NR,NU,NZ,PF,PG,PN,SB,TK,TO,TV,UM,VU,WF,WS' },
      { code:'OT', countries:'AC,TA' }
    ];
    const names = new Intl.DisplayNames(['en'], { type:'region' });
    const countryName = code => ({ US:'United States', GB:'United Kingdom', HK:'Hong Kong SAR', MO:'Macao SAR', TW:'Taiwan' }[code] || names.of(code) || code);
    const routes = new Map();
    for (const group of groups) {
      for (const code of group.countries.split(',')) {
        if (!routes.has(code)) routes.set(code, []);
        routes.get(code).push(group);
      }
    }
    const continent = root.querySelector('[data-vc-continent]');
    const combo = root.querySelector('[data-vc-combobox]');
    const countryInput = root.querySelector('[data-vc-country]');
    const toggle = root.querySelector('[data-vc-toggle]');
    const options = root.querySelector('[data-vc-options]');
    const searchInput = root.querySelector('[data-vc-search]');
    const optionList = root.querySelector('[data-vc-option-list]');
    const empty = root.querySelector('[data-vc-empty]');
    const status = root.querySelector('[data-vc-status]');
    const estimate = root.querySelector('[data-vc-estimate]');
    const routeText = root.querySelector('[data-vc-route]');
    const fallbackText = root.querySelector('[data-vc-fallback]');
    const scope = root.querySelector('[data-vc-scope]');
    const microcopy = root.querySelector('[data-vc-microcopy]');
    const initialResult = { status:status.textContent, estimate:estimate.textContent, route:routeText.textContent };
    const byContinent = new Map(continentGroups.map(group => [group.code, group.countries.split(',')]));
    let selectedCountry = '';
    const closeOptions = () => { options.hidden = true; countryInput.setAttribute('aria-expanded', 'false'); };
    function chooseCountry(code, focusSelected = false) {
      selectedCountry = code;
      countryInput.value = code === 'OTHER' ? root.dataset.unlistedOption : countryName(code);
      closeOptions();
      render();
      if (focusSelected) countryInput.focus();
    }
    function renderOptions() {
      optionList.querySelectorAll('button').forEach(button => button.remove());
      const search = searchInput.value.trim().toLocaleLowerCase();
      const matches = (byContinent.get(continent.value) || []).filter(code => countryName(code).toLocaleLowerCase().includes(search)).sort((a,b) => countryName(a).localeCompare(countryName(b)));
      empty.hidden = matches.length > 0;
      for (const code of [...matches, 'OTHER']) {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('role', 'option');
        button.dataset.code = code;
        button.textContent = code === 'OTHER' ? root.dataset.unlistedOption : countryName(code);
        button.addEventListener('click', () => chooseCountry(code, true));
        optionList.appendChild(button);
      }
    }
    function showOptions() {
      if (!continent.value) return;
      searchInput.value = '';
      renderOptions();
      options.hidden = false;
      countryInput.setAttribute('aria-expanded', 'true');
      searchInput.focus();
    }
    const format = (template, values) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll('{' + key + '}', value), template);
    const range = method => format(root.dataset.range, { min:method.min, max:method.max });
    function render() {
      const code = selectedCountry;
      microcopy.hidden = code === 'BR';
      if (!code) {
        status.textContent = initialResult.status;
        estimate.textContent = initialResult.estimate;
        routeText.textContent = initialResult.route;
        fallbackText.hidden = true;
        scope.hidden = true;
        return;
      }
      if (code === 'OTHER') {
        status.textContent = root.dataset.unlistedStatus;
        estimate.textContent = root.dataset.unlistedEstimate;
        routeText.textContent = root.dataset.unlistedDetail;
        fallbackText.hidden = true;
        scope.hidden = true;
        return;
      }
      if (code === 'BR') {
        status.textContent = format(root.dataset.routeStatus, { country:countryName(code) });
        estimate.textContent = root.dataset.brazilEstimate;
        const contactLink = document.createElement('a');
        contactLink.href = root.dataset.brazilContactUrl;
        contactLink.textContent = root.dataset.brazilContactLabel;
        routeText.replaceChildren(root.dataset.brazilDetail + ' ', contactLink, root.dataset.brazilContactSuffix);
        fallbackText.hidden = true;
        scope.hidden = true;
        return;
      }
      const list = routes.get(code) || [];
      const local = list.find(method => method.type === 'local' && method.origin !== 'China');
      const primary = local || list.reduce((best, method) => !best || method.max < best.max ? method : best, null);
      const fallback = local && list.find(method => method.origin === 'China');
      status.textContent = format(root.dataset.routeStatus, { country:countryName(code) });
      estimate.textContent = range(primary);
      const publicOrigin = primary.origin === 'China' ? root.dataset[primary.type === 'local' ? 'regionalWarehouse' : 'internationalWarehouse'] : primary.origin;
      routeText.textContent = format(root.dataset[primary.type === 'local' ? 'localRoute' : 'internationalRoute'], { origin:publicOrigin });
      fallbackText.hidden = !fallback;
      if (fallback) {
        const [before, after = ''] = root.dataset.fallback.split('{range}');
        const emphasis = document.createElement('strong');
        emphasis.textContent = range(fallback);
        fallbackText.replaceChildren(before, emphasis, after);
      }
      scope.hidden = false;
    }
    continent.addEventListener('change', () => {
      selectedCountry = '';
      countryInput.value = '';
      searchInput.value = '';
      countryInput.disabled = !continent.value;
      toggle.disabled = !continent.value;
      closeOptions();
      render();
    });
    countryInput.addEventListener('click', () => { if (options.hidden) showOptions(); else closeOptions(); });
    countryInput.addEventListener('keydown', event => {
      if (['ArrowDown', 'Enter', ' '].includes(event.key)) { event.preventDefault(); showOptions(); }
      if (event.key === 'Escape') closeOptions();
    });
    searchInput.addEventListener('input', renderOptions);
    searchInput.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown') { event.preventDefault(); optionList.querySelector('button')?.focus(); }
      if (event.key === 'Enter') { event.preventDefault(); optionList.querySelector('button')?.click(); }
      if (event.key === 'Escape') { event.preventDefault(); closeOptions(); countryInput.focus(); }
    });
    toggle.addEventListener('click', () => {
      if (options.hidden) showOptions(); else { closeOptions(); countryInput.focus(); }
    });
    optionList.addEventListener('keydown', event => {
      const buttons = [...optionList.querySelectorAll('button')];
      const index = buttons.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') { event.preventDefault(); buttons[Math.min(index + 1, buttons.length - 1)]?.focus(); }
      if (event.key === 'ArrowUp') { event.preventDefault(); (index <= 0 ? searchInput : buttons[index - 1])?.focus(); }
      if (event.key === 'Escape') { event.preventDefault(); closeOptions(); countryInput.focus(); }
    });
    combo.addEventListener('focusout', () => setTimeout(() => { if (!combo.contains(document.activeElement)) closeOptions(); }, 0));
    document.addEventListener('pointerdown', event => { if (!combo.contains(event.target)) closeOptions(); });
    const defaultCountry = root.dataset.defaultCountry;
    const defaultContinent = continentGroups.find(group => group.countries.split(',').includes(defaultCountry));
    if (defaultContinent && routes.has(defaultCountry)) {
      continent.value = defaultContinent.code;
      countryInput.disabled = false;
      toggle.disabled = false;
      chooseCountry(defaultCountry);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voice-of-venue-anonymous"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.Shopify && window.Shopify.designMode) {
      return;
    }

    const publicPath = '/pages/vov/church/us/trinity-church-menlo-park';

    if (window.location.pathname !== publicPath) {
      window.history.replaceState(
        window.history.state,
        '',
        `${publicPath}${window.location.search}${window.location.hash}`
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voice-of-venue-trinity-story"] && !Shopify.designMode) return;
  try {
    
  (() =>  {
    if (window.Shopify && window.Shopify.designMode) {
      return;
    }
    {
      const publicPath = '/pages/vov/church/us/trinity-church-menlo-park';
      if (window.location.pathname !== publicPath) {
        window.history.replaceState(window.history.state, '', `${publicPath}${window.location.search}${window.location.hash}`);
      }
    }

    const gallery = document.querySelector('.vov-record__visuals');
    const lightbox = document.querySelector('.vov-record__lightbox');
    if (gallery && lightbox) {
      const lightboxImage = lightbox.querySelector('img');
      const closeButton = lightbox.querySelector('.vov-record__lightbox-close');
      const previousButton = lightbox.querySelector('.vov-record__lightbox-prev');
      const nextButton = lightbox.querySelector('.vov-record__lightbox-next');
      const galleryItems = Array.from(gallery.querySelectorAll('[data-vov-gallery-image]'));
      let activeIndex = 0;
      const showImage = (index) => {
        activeIndex = (index + galleryItems.length) % galleryItems.length;
        const trigger = galleryItems[activeIndex];
        const thumbnail = trigger.querySelector('img');
        lightboxImage.src = trigger.dataset.vovGalleryImage;
        lightboxImage.alt = thumbnail ? thumbnail.alt : '';
      };
      gallery.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-vov-gallery-image]');
        if (!trigger) return;
        showImage(galleryItems.indexOf(trigger));
        lightbox.showModal();
      });
      previousButton.addEventListener('click', () => showImage(activeIndex - 1));
      nextButton.addEventListener('click', () => showImage(activeIndex + 1));
      closeButton.addEventListener('click', () => lightbox.close());
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });
      lightbox.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showImage(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showImage(activeIndex + 1);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wireless-multi-speaker-events"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-speaker-collection]').forEach((root) => {
      if (root.dataset.filterReady) return;
      const filters = root.querySelector('.wmss-refresh__filters');
      const count = root.querySelector('[data-filter-count]');
      const cards = Array.from(root.querySelectorAll('[data-category]'));
      if (!filters || !count) return;
      root.dataset.filterReady = 'true';
      const select = (category) => {
        let visible = 0;
        cards.forEach((card) => {
          card.hidden = category !== 'all' && card.dataset.category !== category;
          if (!card.hidden) visible++;
        });
        filters.querySelectorAll('[data-filter]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.filter === category));
        });
        count.textContent = String(visible);
      };
      filters.addEventListener('click', (event) => {
        const button = event.target.closest('[data-filter]');
        if (button && filters.contains(button)) select(button.dataset.filter);
      });
      select('all');
      filters.hidden = false;
      count.parentElement.hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
